// import React, { useState, useEffect, useRef } from 'react';
// import Sidebar from './components/Sidebar';
// import Footer from './components/Footer';
// import DeviceList from './pages/DeviceList';
// import RechargeManagement from './pages/RechargeManagement';
// import Analytics from './pages/Analytics';
// import Miscellaneous from './pages/Miscellaneous';
// import Profile from './pages/Profile';
// import SignIn from './pages/SignIn';
// import { getCurrentSession, signOut } from './cognito';
// import Support from './pages/Support';
// import ServiceManager from './pages/ServiceManager';
// import CustomerEngineer from './pages/CustomerEngineer';
// import { useMqttProxy } from './mqttProxy';
// import { aesDecrypt, hexToString } from './cryptoUtils';
// import { getManagerByEmail, getCEByEmail } from './supportConfig';
// import RefreshmentsPage from './RefreshmentsPage';
// import BatteryHealthPage from './BatteryHealthPage';
// import './App.css';

// // ── Global TAM config & helpers ─────────────────────────────────────────────
// const GLOBAL_TAM_CFG = {
//   '1': { title:'Pump Tamper Detected',        badge:'PUMP TAMPER',        color:'#FF3B30', bg:'linear-gradient(135deg,#FF3B30,#CC0000)', shadow:'rgba(255,59,48,.4)' },
//   '2': { title:'Flow Sensor Tamper Detected', badge:'FLOW SENSOR TAMPER', color:'#FF9F0A', bg:'linear-gradient(135deg,#FF9F0A,#CC7A00)', shadow:'rgba(255,159,10,.4)' },
// };
// const RESP_TOPIC_FOR = (mac) => `/hoags/livpure/lotier/waas/response/${mac.replace(/[^a-f0-9]/gi,'').toLowerCase()}/`;
// const TAM_KEY = (mac) => `hoags_tam_history_${mac}`;

// function globalSaveTamEvent(mac, tamCode, deviceName, location, serialNo) {
//   try {
//     const raw = JSON.parse(localStorage.getItem(TAM_KEY(mac)) || '[]');
//     const cfg = GLOBAL_TAM_CFG[tamCode]; if (!cfg) return false;
//     const cutoff24h = Date.now() - 24 * 60 * 60 * 1000;

//     // Overwrite rule: only 1 entry per tamCode per device (latest wins)
//     const existingIdx = raw.findIndex(h => h.tamCode === tamCode);
//     const existing    = existingIdx >= 0 ? raw[existingIdx] : null;
//     const suppressAlert = existing &&
//       new Date(existing.detectedAt).getTime() > cutoff24h;

//     const newEntry = {
//       id: Date.now(), tamCode, type: cfg.badge, title: cfg.title,
//       device: deviceName, mac,
//       location: location || '',
//       serialNo: serialNo || '',
//       detectedAt: new Date().toISOString(), acknowledgedAt: null,
//     };

//     let updated;
//     if (existingIdx >= 0) {
//       updated = [...raw];
//       updated[existingIdx] = newEntry;
//     } else {
//       updated = [newEntry, ...raw];
//     }
//     localStorage.setItem(TAM_KEY(mac), JSON.stringify(updated.slice(0, 200)));
//     return !suppressAlert;
//   } catch(e) { return false; }
// }

// // ── Global TAM Toast ─────────────────────────────────────────────────────────
// function GlobalTamToast({ alerts, onDismiss }) {
//   if (alerts.length === 0) return null;
//   const alert = alerts[0]; // show latest
//   const cfg = GLOBAL_TAM_CFG[alert.tamCode];
//   if (!cfg) return null;
//   return (
//     <div style={{
//       position:'fixed', bottom:24, right:24, zIndex:999999,
//       width:320, borderRadius:18,
//       background:'#fff',
//       boxShadow:'0 12px 48px rgba(0,0,0,.25), 0 2px 8px rgba(0,0,0,.1)',
//       border:`1.5px solid ${cfg.color}30`,
//       overflow:'hidden',
//       animation:'gTamSlideIn .35s cubic-bezier(.34,1.56,.64,1)',
//       fontFamily:"-apple-system,BlinkMacSystemFont,'SF Pro Display',sans-serif",
//     }}>
//       <div style={{ height:4, background:cfg.bg }}/>
//       <div style={{ padding:'14px 16px 16px', display:'flex', flexDirection:'column', gap:10 }}>
//         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//           <div style={{
//             width:36, height:36, borderRadius:10, flexShrink:0,
//             background:cfg.bg,
//             display:'flex', alignItems:'center', justifyContent:'center',
//             boxShadow:`0 3px 10px ${cfg.shadow}`,
//             animation:'gTamPulse 1.8s ease-in-out infinite',
//           }}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//               <path d="M12 2L2 19h20L12 2Z" fill="white" fillOpacity=".3"
//                 stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
//               <path d="M12 9v5" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
//               <circle cx="12" cy="17" r="1.2" fill="white"/>
//             </svg>
//           </div>
//           <div style={{ flex:1, minWidth:0 }}>
//             <div style={{ fontSize:13, fontWeight:800, color:'#1c1c1e', marginBottom:1 }}>{cfg.title}</div>
//             <div style={{ fontSize:10, fontWeight:700, color:cfg.color, letterSpacing:.6 }}>{cfg.badge}</div>
//           </div>
//           <button onClick={()=>onDismiss(alert.key)} style={{
//             width:24, height:24, borderRadius:'50%', border:'none',
//             background:'rgba(0,0,0,.07)', cursor:'pointer', flexShrink:0,
//             display:'flex', alignItems:'center', justifyContent:'center',
//             fontSize:13, color:'#636366',
//           }}>×</button>
//         </div>
//         <div style={{
//           fontSize:12, color:'#48484a', lineHeight:1.55,
//           background:'rgba(0,0,0,.025)', borderRadius:10, padding:'9px 12px',
//         }}>
//           <div><strong>Device:</strong> {alert.deviceName}</div>
//           <div style={{ fontFamily:'monospace', fontSize:11, color:'#8E8E93' }}>{alert.mac}</div>
//           {alert.location && <div style={{ fontSize:11, color:'#8E8E93', marginTop:2 }}>📍 {alert.location}</div>}
//           {alert.serialNo  && <div style={{ fontSize:11, color:'#8E8E93' }}>🔖 {alert.serialNo}</div>}
//           <div style={{ marginTop:3, color:'#8E8E93', fontSize:11 }}>
//             {new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit',hour12:true})} · {new Date().toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}
//           </div>
//         </div>
//         <button onClick={()=>onDismiss(alert.key)} style={{
//           flex:1, padding:'9px', borderRadius:10, border:'none',
//           background:cfg.bg, color:'#fff', fontWeight:700, fontSize:12,
//           cursor:'pointer', fontFamily:'inherit',
//           boxShadow:`0 2px 8px ${cfg.shadow}`,
//         }}>Acknowledge</button>
//         <div style={{ fontSize:10, color:'#aeaeb2', textAlign:'center' }}>Saved to tamper history</div>
//       </div>
//       <style>{`
//         @keyframes gTamSlideIn { from{opacity:0;transform:translateX(120px) scale(.9)} to{opacity:1;transform:translateX(0) scale(1)} }
//         @keyframes gTamPulse   { 0%,100%{transform:scale(1)} 50%{transform:scale(1.08)} }
//       `}</style>
//     </div>
//   );
// }

// const SPLASH_STEPS = [
//   { icon: '🔐', text: 'Verifying your identity…'    },
//   { icon: '🌐', text: 'Connecting to Havells Cloud…'  },
//   { icon: '📡', text: 'Initialising MQTT proxy…'    },
//   { icon: '✅',   text: 'All set! Welcome back.'        },
// ];

// function SplashLoader({ onDone }) {
//   const [idx, setIdx] = useState(0);
//   const [fade, setFade] = useState(true);

//   useEffect(() => {
//     if (idx >= SPLASH_STEPS.length - 1) {
//       const t = setTimeout(onDone, 1200);
//       return () => clearTimeout(t);
//     }
//     const t = setTimeout(() => {
//       setFade(false);
//       setTimeout(() => { setIdx(i => i + 1); setFade(true); }, 300);
//     }, 2000);
//     return () => clearTimeout(t);
//   }, [idx, onDone]);

//   const step = SPLASH_STEPS[idx];
//   const progress = ((idx + 1) / SPLASH_STEPS.length) * 100;

//   return (
//     <div style={{
//       position: 'fixed', inset: 0, zIndex: 9999,
//       background: '#f8f9fa',
//       display: 'flex', flexDirection: 'column',
//       alignItems: 'center', justifyContent: 'center', gap: 0,
//     }}>
//       <style>{`
//         @keyframes splashPulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:.85} }
//         @keyframes iosBar { from{opacity:1} to{opacity:.15} }
//       `}</style>

//       <div style={{
//         width: 80, height: 80, borderRadius: 18, background: 'transparent',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         marginBottom: 24,
//         animation: 'splashPulse 2s ease-in-out infinite', overflow: 'visible',
//       }}>
//         <img src="/havells-logo.png" alt="Havells" style={{ height: 70, width: 'auto', objectFit: 'contain' }}/>
//       </div>

//       <div style={{ fontSize: 26, fontWeight: 800, color: '#1c1c1e', letterSpacing: -.5, marginBottom: 6,
//         fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>Havells Admin</div>
//       <div style={{ fontSize: 13, color: 'rgba(0,0,0,.4)', marginBottom: 52,
//         fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>Smart Device Management</div>

//       <div style={{ position: 'relative', width: 44, height: 44, marginBottom: 32 }}>
//         {Array.from({ length: 12 }).map((_, i) => (
//           <div key={i} style={{
//             position: 'absolute', top: '50%', left: '50%',
//             width: 3.5, height: 10, borderRadius: 2, background: '#DC2626',
//             transformOrigin: '50% 160%',
//             transform: `rotate(${i * 30}deg) translateX(-50%)`,
//             animation: `iosBar 1s linear ${-(12 - i) / 12}s infinite`,
//           }} />
//         ))}
//       </div>

//       <div style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.3s ease', textAlign: 'center',
//         marginBottom: 40, fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>
//         <div style={{ fontSize: 22, marginBottom: 8 }}>{step.icon}</div>
//         <div style={{ fontSize: 14, color: 'rgba(0,0,0,.55)', fontWeight: 500 }}>{step.text}</div>
//       </div>

//       <div style={{ width: 200, height: 3, background: 'rgba(0,0,0,.08)', borderRadius: 999, overflow: 'hidden' }}>
//         <div style={{
//           height: '100%', borderRadius: 999,
//           background: 'linear-gradient(90deg,#DC2626,#EF4444)',
//           width: `${progress}%`, transition: 'width 0.5s ease',
//           boxShadow: '0 0 8px rgba(220,38,38,.4)',
//         }} />
//       </div>

//       <div style={{ display: 'flex', gap: 6, marginTop: 16 }}>
//         {SPLASH_STEPS.map((_, i) => (
//           <div key={i} style={{
//             width: i === idx ? 18 : 6, height: 6, borderRadius: 3,
//             background: i <= idx ? '#DC2626' : 'rgba(0,0,0,.1)',
//             transition: 'all 0.4s ease',
//           }} />
//         ))}
//       </div>
//     </div>
//   );
// }

// export default function App() {
//   const [session,          setSession]          = useState(null);
//   const [authLoading,      setAuthLoading]      = useState(true);
//   const [activePage,       setActivePage]       = useState('dashboard');
//   const [miscSubPage,      setMiscSubPage]      = useState(null); // 'pump' | 'flow' | null
//   const [showSplash,       setShowSplash]       = useState(false);
//   const [pendingSession,   setPendingSession]   = useState(null);
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [userRole,         setUserRole]         = useState(() => sessionStorage.getItem('hoags_role') || 'user');
//   const [globalTamAlerts,  setGlobalTamAlerts]  = useState([]);
//   const [allDevices,       setAllDevices]       = useState([]);
//   const tamSeenRef = useRef(new Set());

//   const { connected, subscribe } = useMqttProxy();
//   const toggleSidebar = () => setSidebarCollapsed(c => !c);

//   // ── Load devices & subscribe to all response topics for global TAM ────────
//   useEffect(() => {
//     fetch('/api/admin-devices', { headers:{'ngrok-skip-browser-warning':'true'} })
//       .then(r => r.json())
//       .then(data => {
//         const arr = Array.isArray(data) ? data : (data.registrations??data.data??data.devices??[]);
//         setAllDevices(arr);
//       }).catch(()=>{});
//   }, []);

//   useEffect(() => {
//     if (!connected || allDevices.length === 0) return;
//     const unsubs = allDevices.map(device => {
//       const mac = (device.mac_id||device.macid||'').replace(/[^a-fA-F0-9]/g,'').toLowerCase();
//       if (!mac) return null;
//       const topic = RESP_TOPIC_FOR(mac);
//       return subscribe(topic, async (message) => {
//         try {
//           const raw = typeof message === 'string' ? message : JSON.stringify(message);
//           let json;
//           try { json = JSON.parse(raw); } catch { return; }
//           // Decrypt if long hex VAL
//           if (json.VAL && /^[0-9a-fA-F]+$/.test(json.VAL) && json.VAL.length > 20) {
//             try {
//               // Try to get K2 from window (set by DeviceStatus when active)
//               const k2 = window.__hoagsK2?.[mac];
//               if (k2) {
//                 const decHex = await aesDecrypt(json.VAL, k2);
//                 json = JSON.parse(hexToString(decHex));
//               } else { return; }
//             } catch { return; }
//           }
//           if (json.CMD !== 'TAM') return;
//           const tamCode = String(json.VAL);
//           const seenKey = `${mac}-${tamCode}-${Math.floor(Date.now()/20000)}`; // 20s window
//           if (!GLOBAL_TAM_CFG[tamCode] || tamSeenRef.current.has(seenKey)) return;
//           tamSeenRef.current.add(seenKey);
//           const deviceName = device.friendly_name || device.friendlyname || mac;
//           const location   = device.location || device._registration?.location || '';
//           const serialNo   = device.version_no || device.versionNo || '';
//           const isNew = globalSaveTamEvent(mac, tamCode, deviceName, location, serialNo);
//           if (!isNew) return; // suppressed — duplicate within 24h
//           const alertKey = `${mac}-${tamCode}-${Date.now()}`;
//           setGlobalTamAlerts(prev => [{ key:alertKey, mac, tamCode, deviceName, location, serialNo }, ...prev]);
//           // Send email
//           fetch('/api/tamper-alert', {
//             method:'POST', headers:{'Content-Type':'application/json'},
//             body: JSON.stringify({ tamCode, deviceName, mac, tamType: GLOBAL_TAM_CFG[tamCode]?.badge,
//               detectedAt: new Date().toISOString(), location, serialNo }),
//           }).catch(()=>{});
//         } catch(e) {}
//       });
//     }).filter(Boolean);
//     return () => unsubs.forEach(u => u && u());
//   }, [connected, allDevices, subscribe]);

//   useEffect(() => {
//     getCurrentSession()
//       .then(s => setSession(s))
//       .catch(() => setSession(null))
//       .finally(() => setAuthLoading(false));
//   }, []);

//   const handleSignedIn = (s, role = 'user') => {
//     // Auto-detect role from email if not explicitly set
//     const email = s?.getIdToken()?.payload?.email || '';
//     let detectedRole = role;
//     if (!role || role === 'user') {
//       if (getManagerByEmail(email)) detectedRole = 'service_manager';
//       else if (getCEByEmail(email)) detectedRole = 'customer_engineer';
//       else detectedRole = 'admin';
//     }
//     setUserRole(detectedRole);
//     sessionStorage.setItem('hoags_role', detectedRole);
//     setPendingSession(s);
//     setShowSplash(true);
//   };

//   const handleSplashDone = () => {
//     setShowSplash(false);
//     setSession(pendingSession);
//     setPendingSession(null);
//   };

//   const handleSignOut = () => {
//     signOut();
//     sessionStorage.removeItem('hoags_role');
//     setUserRole('user');
//     setSession(null);
//     setActivePage('dashboard');
//   };

//   const userId = session?.getIdToken()?.payload?.sub || null;

//   if (authLoading) {
//     return (
//       <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
//         justifyContent: 'center', background: '#f8f9fa', flexDirection: 'column', gap: 16 }}>
//         <style>{`@keyframes spin { to { transform:rotate(360deg); } }`}</style>
//         <div style={{ width: 28, height: 28, border: '3px solid rgba(220,38,38,0.15)',
//           borderTopColor: '#DC2626', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}/>
//         <p style={{ color: '#8E8E93', fontSize: 14 }}>Loading…</p>
//       </div>
//     );
//   }

//   if (showSplash) return <SplashLoader onDone={handleSplashDone} />;
//   if (!session)    return <SignIn onSignedIn={handleSignedIn} />;

//   const isAdmin   = userRole === 'admin';
//   const isMgr     = userRole === 'service_manager';
//   const isCE      = userRole === 'customer_engineer';

//   // Service Manager — full screen with sign out
//   if (isMgr) return (
//     <div className="app-layout">
//       <main className="main-content" style={{marginLeft:0,paddingTop:24}}>
//         <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16,paddingRight:4}}>
//           <button onClick={handleSignOut} style={{padding:'8px 16px',borderRadius:10,border:'1.5px solid rgba(0,0,0,.1)',background:'#fff',color:'#636366',fontSize:13,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
//             Sign Out
//           </button>
//         </div>
//         <ServiceManager session={session}/>
//       </main>
//     </div>
//   );

//   // Customer Engineer — full screen with sign out
//   if (isCE) return (
//     <div className="app-layout">
//       <main className="main-content" style={{marginLeft:0,paddingTop:24}}>
//         <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16,paddingRight:4}}>
//           <button onClick={handleSignOut} style={{padding:'8px 16px',borderRadius:10,border:'1.5px solid rgba(0,0,0,.1)',background:'#fff',color:'#636366',fontSize:13,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
//             Sign Out
//           </button>
//         </div>
//         <CustomerEngineer session={session}/>
//       </main>
//     </div>
//   );

//   const renderPage = () => {
//     switch (activePage) {
//       case 'dashboard': return <DeviceList userId={userId} isAdmin={isAdmin}/>;
//       case 'recharge':  return <RechargeManagement userId={userId} isAdmin={isAdmin}/>;
//       case 'analytics':     return isAdmin ? <Analytics session={session}/> : <DeviceList userId={userId} isAdmin={false}/>;
//       case 'miscellaneous':  return isAdmin ? <Miscellaneous subPage={miscSubPage}/> : <DeviceList userId={userId} isAdmin={false}/>;
//       case 'support':   return isAdmin ? <Support/> : <DeviceList userId={userId} isAdmin={false}/>;
//       case 'profile':   return <Profile session={session} onSignOut={handleSignOut} role={userRole}/>;
//       default:          return <DeviceList userId={userId} isAdmin={isAdmin}/>;
//     }
//   };

//   const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

//   return (
//     <div className="app-layout">
//       {isMobile && !sidebarCollapsed && (
//         <div onClick={toggleSidebar} style={{
//           position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
//           zIndex: 399, backdropFilter: 'blur(2px)',
//         }}/>
//       )}
//       <Sidebar
//         activePage={activePage} setActivePage={(page) => { if (page !== 'miscellaneous') setMiscSubPage(null); setActivePage(page); }}
//         onSignOut={handleSignOut} session={session}
//         collapsed={sidebarCollapsed} onToggle={toggleSidebar} role={userRole}
//         miscSubPage={miscSubPage} setMiscSubPage={(sub) => { setMiscSubPage(sub); setActivePage('miscellaneous'); }}
//       />
//       <main className="main-content" style={{ transition: 'margin-left 0.28s cubic-bezier(.4,0,.2,1)' }}>
//         <div className="mobile-topbar">
//           <button onClick={toggleSidebar} style={{
//             width: 36, height: 36, borderRadius: 9,
//             background: 'rgba(0,0,0,0.06)', border: 'none',
//             cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
//           }}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//               <path d="M3 6h18M3 12h18M3 18h18" stroke="#1c1c1e" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//           <span style={{ fontSize: 15, fontWeight: 700, color: '#1c1c1e', letterSpacing: -.3 }}>Havells Waas</span>
//           <div style={{ width: 36 }}/>
//         </div>
//         {renderPage()}
//         <Footer/>
//       </main>
//       {/* Global TAM Toast — shows on ANY page */}
//       <GlobalTamToast
//         alerts={globalTamAlerts}
//         onDismiss={(key) => setGlobalTamAlerts(prev => prev.filter(a => a.key !== key))}
//       />
//     </div>
//   );
// }


// import React, { useState, useEffect, useRef } from 'react';
// import Sidebar from './components/Sidebar';
// import Footer from './components/Footer';
// import DeviceList from './pages/DeviceList';
// import RechargeManagement from './pages/RechargeManagement';
// import Analytics from './pages/Analytics';
// import Miscellaneous from './pages/Miscellaneous';
// import TamperPage from './pages/TamperPage';
// import RefreshmentsPage from './pages/RefreshmentsPage';
// import BatteryHealthPage from './pages/BatteryHealthPage';
// import Profile from './pages/Profile';
// import SignIn from './pages/SignIn';
// import { getCurrentSession, signOut } from './cognito';
// import Support from './pages/Support';
// import ServiceManager from './pages/ServiceManager';
// import CustomerEngineer from './pages/CustomerEngineer';
// import { useMqttProxy } from './mqttProxy';
// import { aesDecrypt, hexToString } from './cryptoUtils';
// import { getManagerByEmail, getCEByEmail } from './supportConfig';
// import './App.css';

// // ── Global TAM config & helpers ─────────────────────────────────────────────
// const GLOBAL_TAM_CFG = {
//   '1': { title:'Pump Tamper Detected',        badge:'PUMP TAMPER',        color:'#FF3B30', bg:'linear-gradient(135deg,#FF3B30,#CC0000)', shadow:'rgba(255,59,48,.4)' },
//   '2': { title:'Flow Sensor Tamper Detected', badge:'FLOW SENSOR TAMPER', color:'#FF9F0A', bg:'linear-gradient(135deg,#FF9F0A,#CC7A00)', shadow:'rgba(255,159,10,.4)' },
// };
// const RESP_TOPIC_FOR = (mac) => `/hoags/livpure/lotier/waas/response/${mac.replace(/[^a-f0-9]/gi,'').toLowerCase()}/`;
// const TAM_KEY = (mac) => `hoags_tam_history_${mac}`;

// function globalSaveTamEvent(mac, tamCode, deviceName, location, serialNo) {
//   try {
//     const raw = JSON.parse(localStorage.getItem(TAM_KEY(mac)) || '[]');
//     const cfg = GLOBAL_TAM_CFG[tamCode]; if (!cfg) return false;
//     const cutoff24h = Date.now() - 24 * 60 * 60 * 1000;

//     const existingIdx = raw.findIndex(h => h.tamCode === tamCode);
//     const existing    = existingIdx >= 0 ? raw[existingIdx] : null;
//     const suppressAlert = existing &&
//       new Date(existing.detectedAt).getTime() > cutoff24h;

//     const newEntry = {
//       id: Date.now(), tamCode, type: cfg.badge, title: cfg.title,
//       device: deviceName, mac,
//       location: location || '',
//       serialNo: serialNo || '',
//       detectedAt: new Date().toISOString(), acknowledgedAt: null,
//     };

//     let updated;
//     if (existingIdx >= 0) {
//       updated = [...raw];
//       updated[existingIdx] = newEntry;
//     } else {
//       updated = [newEntry, ...raw];
//     }
//     localStorage.setItem(TAM_KEY(mac), JSON.stringify(updated.slice(0, 200)));
//     return !suppressAlert;
//   } catch(e) { return false; }
// }

// // ── Global TAM Toast ─────────────────────────────────────────────────────────
// function GlobalTamToast({ alerts, onDismiss }) {
//   if (alerts.length === 0) return null;
//   const alert = alerts[0];
//   const cfg = GLOBAL_TAM_CFG[alert.tamCode];
//   if (!cfg) return null;
//   return (
//     <div style={{
//       position:'fixed', bottom:24, right:24, zIndex:999999,
//       width:320, borderRadius:18,
//       background:'#fff',
//       boxShadow:'0 12px 48px rgba(0,0,0,.25), 0 2px 8px rgba(0,0,0,.1)',
//       border:`1.5px solid ${cfg.color}30`,
//       overflow:'hidden',
//       animation:'gTamSlideIn .35s cubic-bezier(.34,1.56,.64,1)',
//       fontFamily:"-apple-system,BlinkMacSystemFont,'SF Pro Display',sans-serif",
//     }}>
//       <div style={{ height:4, background:cfg.bg }}/>
//       <div style={{ padding:'14px 16px 16px', display:'flex', flexDirection:'column', gap:10 }}>
//         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//           <div style={{
//             width:36, height:36, borderRadius:10, flexShrink:0,
//             background:cfg.bg,
//             display:'flex', alignItems:'center', justifyContent:'center',
//             boxShadow:`0 3px 10px ${cfg.shadow}`,
//             animation:'gTamPulse 1.8s ease-in-out infinite',
//           }}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//               <path d="M12 2L2 19h20L12 2Z" fill="white" fillOpacity=".3"
//                 stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
//               <path d="M12 9v5" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
//               <circle cx="12" cy="17" r="1.2" fill="white"/>
//             </svg>
//           </div>
//           <div style={{ flex:1, minWidth:0 }}>
//             <div style={{ fontSize:13, fontWeight:800, color:'#1c1c1e', marginBottom:1 }}>{cfg.title}</div>
//             <div style={{ fontSize:10, fontWeight:700, color:cfg.color, letterSpacing:.6 }}>{cfg.badge}</div>
//           </div>
//           <button onClick={()=>onDismiss(alert.key)} style={{
//             width:24, height:24, borderRadius:'50%', border:'none',
//             background:'rgba(0,0,0,.07)', cursor:'pointer', flexShrink:0,
//             display:'flex', alignItems:'center', justifyContent:'center',
//             fontSize:13, color:'#636366',
//           }}>×</button>
//         </div>
//         <div style={{
//           fontSize:12, color:'#48484a', lineHeight:1.55,
//           background:'rgba(0,0,0,.025)', borderRadius:10, padding:'9px 12px',
//         }}>
//           <div><strong>Device:</strong> {alert.deviceName}</div>
//           <div style={{ fontFamily:'monospace', fontSize:11, color:'#8E8E93' }}>{alert.mac}</div>
//           {alert.location && <div style={{ fontSize:11, color:'#8E8E93', marginTop:2 }}>📍 {alert.location}</div>}
//           {alert.serialNo  && <div style={{ fontSize:11, color:'#8E8E93' }}>🔖 {alert.serialNo}</div>}
//           <div style={{ marginTop:3, color:'#8E8E93', fontSize:11 }}>
//             {new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit',hour12:true})} · {new Date().toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}
//           </div>
//         </div>
//         <button onClick={()=>onDismiss(alert.key)} style={{
//           flex:1, padding:'9px', borderRadius:10, border:'none',
//           background:cfg.bg, color:'#fff', fontWeight:700, fontSize:12,
//           cursor:'pointer', fontFamily:'inherit',
//           boxShadow:`0 2px 8px ${cfg.shadow}`,
//         }}>Acknowledge</button>
//         <div style={{ fontSize:10, color:'#aeaeb2', textAlign:'center' }}>Saved to tamper history</div>
//       </div>
//       <style>{`
//         @keyframes gTamSlideIn { from{opacity:0;transform:translateX(120px) scale(.9)} to{opacity:1;transform:translateX(0) scale(1)} }
//         @keyframes gTamPulse   { 0%,100%{transform:scale(1)} 50%{transform:scale(1.08)} }
//       `}</style>
//     </div>
//   );
// }

// const SPLASH_STEPS = [
//   { icon: '🔐', text: 'Verifying your identity…'    },
//   { icon: '🌐', text: 'Connecting to Havells Cloud…'  },
//   { icon: '📡', text: 'Initialising MQTT proxy…'    },
//   { icon: '✅',   text: 'All set! Welcome back.'        },
// ];

// function SplashLoader({ onDone }) {
//   const [idx, setIdx] = useState(0);
//   const [fade, setFade] = useState(true);

//   useEffect(() => {
//     if (idx >= SPLASH_STEPS.length - 1) {
//       const t = setTimeout(onDone, 1200);
//       return () => clearTimeout(t);
//     }
//     const t = setTimeout(() => {
//       setFade(false);
//       setTimeout(() => { setIdx(i => i + 1); setFade(true); }, 300);
//     }, 2000);
//     return () => clearTimeout(t);
//   }, [idx, onDone]);

//   const step = SPLASH_STEPS[idx];
//   const progress = ((idx + 1) / SPLASH_STEPS.length) * 100;

//   return (
//     <div style={{
//       position: 'fixed', inset: 0, zIndex: 9999,
//       background: '#f8f9fa',
//       display: 'flex', flexDirection: 'column',
//       alignItems: 'center', justifyContent: 'center', gap: 0,
//     }}>
//       <style>{`
//         @keyframes splashPulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:.85} }
//         @keyframes iosBar { from{opacity:1} to{opacity:.15} }
//       `}</style>

//       <div style={{
//         width: 80, height: 80, borderRadius: 18, background: 'transparent',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         marginBottom: 24,
//         animation: 'splashPulse 2s ease-in-out infinite', overflow: 'visible',
//       }}>
//         <img src="/havells-logo.png" alt="Havells" style={{ height: 70, width: 'auto', objectFit: 'contain' }}/>
//       </div>

//       <div style={{ fontSize: 26, fontWeight: 800, color: '#1c1c1e', letterSpacing: -.5, marginBottom: 6,
//         fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>Havells Admin</div>
//       <div style={{ fontSize: 13, color: 'rgba(0,0,0,.4)', marginBottom: 52,
//         fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>Smart Device Management</div>

//       <div style={{ position: 'relative', width: 44, height: 44, marginBottom: 32 }}>
//         {Array.from({ length: 12 }).map((_, i) => (
//           <div key={i} style={{
//             position: 'absolute', top: '50%', left: '50%',
//             width: 3.5, height: 10, borderRadius: 2, background: '#DC2626',
//             transformOrigin: '50% 160%',
//             transform: `rotate(${i * 30}deg) translateX(-50%)`,
//             animation: `iosBar 1s linear ${-(12 - i) / 12}s infinite`,
//           }} />
//         ))}
//       </div>

//       <div style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.3s ease', textAlign: 'center',
//         marginBottom: 40, fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>
//         <div style={{ fontSize: 22, marginBottom: 8 }}>{step.icon}</div>
//         <div style={{ fontSize: 14, color: 'rgba(0,0,0,.55)', fontWeight: 500 }}>{step.text}</div>
//       </div>

//       <div style={{ width: 200, height: 3, background: 'rgba(0,0,0,.08)', borderRadius: 999, overflow: 'hidden' }}>
//         <div style={{
//           height: '100%', borderRadius: 999,
//           background: 'linear-gradient(90deg,#DC2626,#EF4444)',
//           width: `${progress}%`, transition: 'width 0.5s ease',
//           boxShadow: '0 0 8px rgba(220,38,38,.4)',
//         }} />
//       </div>

//       <div style={{ display: 'flex', gap: 6, marginTop: 16 }}>
//         {SPLASH_STEPS.map((_, i) => (
//           <div key={i} style={{
//             width: i === idx ? 18 : 6, height: 6, borderRadius: 3,
//             background: i <= idx ? '#DC2626' : 'rgba(0,0,0,.1)',
//             transition: 'all 0.4s ease',
//           }} />
//         ))}
//       </div>
//     </div>
//   );
// }

// export default function App() {
//   const [session,          setSession]          = useState(null);
//   const [authLoading,      setAuthLoading]      = useState(true);
//   const [activePage,       setActivePage]       = useState('dashboard');
//   const [miscSubPage,      setMiscSubPage]      = useState(null); // 'tamper' | 'dryrun' | 'refreshments' | 'batteryhealth' | null
//   const [showSplash,       setShowSplash]       = useState(false);
//   const [pendingSession,   setPendingSession]   = useState(null);
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [userRole,         setUserRole]         = useState(() => sessionStorage.getItem('hoags_role') || 'user');
//   const [globalTamAlerts,  setGlobalTamAlerts]  = useState([]);
//   const [allDevices,       setAllDevices]       = useState([]);
//   const tamSeenRef = useRef(new Set());

//   const { connected, subscribe } = useMqttProxy();
//   const toggleSidebar = () => setSidebarCollapsed(c => !c);

//   // ── Load devices & subscribe to all response topics for global TAM ────────
//   useEffect(() => {
//     fetch('/api/admin-devices', { headers:{'ngrok-skip-browser-warning':'true'} })
//       .then(r => r.json())
//       .then(data => {
//         const arr = Array.isArray(data) ? data : (data.registrations??data.data??data.devices??[]);
//         setAllDevices(arr);
//       }).catch(()=>{});
//   }, []);

//   useEffect(() => {
//     if (!connected || allDevices.length === 0) return;
//     const unsubs = allDevices.map(device => {
//       const mac = (device.mac_id||device.macid||'').replace(/[^a-fA-F0-9]/g,'').toLowerCase();
//       if (!mac) return null;
//       const topic = RESP_TOPIC_FOR(mac);
//       return subscribe(topic, async (message) => {
//         try {
//           const raw = typeof message === 'string' ? message : JSON.stringify(message);
//           let json;
//           try { json = JSON.parse(raw); } catch { return; }
//           if (json.VAL && /^[0-9a-fA-F]+$/.test(json.VAL) && json.VAL.length > 20) {
//             try {
//               const k2 = window.__hoagsK2?.[mac];
//               if (k2) {
//                 const decHex = await aesDecrypt(json.VAL, k2);
//                 json = JSON.parse(hexToString(decHex));
//               } else { return; }
//             } catch { return; }
//           }
//           if (json.CMD !== 'TAM') return;
//           const tamCode = String(json.VAL);
//           const seenKey = `${mac}-${tamCode}-${Math.floor(Date.now()/20000)}`;
//           if (!GLOBAL_TAM_CFG[tamCode] || tamSeenRef.current.has(seenKey)) return;
//           tamSeenRef.current.add(seenKey);
//           const deviceName = device.friendly_name || device.friendlyname || mac;
//           const location   = device.location || device._registration?.location || '';
//           const serialNo   = device.version_no || device.versionNo || '';
//           const isNew = globalSaveTamEvent(mac, tamCode, deviceName, location, serialNo);
//           if (!isNew) return;
//           const alertKey = `${mac}-${tamCode}-${Date.now()}`;
//           setGlobalTamAlerts(prev => [{ key:alertKey, mac, tamCode, deviceName, location, serialNo }, ...prev]);
//           fetch('/api/tamper-alert', {
//             method:'POST', headers:{'Content-Type':'application/json'},
//             body: JSON.stringify({ tamCode, deviceName, mac, tamType: GLOBAL_TAM_CFG[tamCode]?.badge,
//               detectedAt: new Date().toISOString(), location, serialNo }),
//           }).catch(()=>{});
//         } catch(e) {}
//       });
//     }).filter(Boolean);
//     return () => unsubs.forEach(u => u && u());
//   }, [connected, allDevices, subscribe]);

//   useEffect(() => {
//     getCurrentSession()
//       .then(s => setSession(s))
//       .catch(() => setSession(null))
//       .finally(() => setAuthLoading(false));
//   }, []);

//   const handleSignedIn = (s, role = 'user') => {
//     const email = s?.getIdToken()?.payload?.email || '';
//     let detectedRole = role;
//     if (!role || role === 'user') {
//       if (getManagerByEmail(email)) detectedRole = 'service_manager';
//       else if (getCEByEmail(email)) detectedRole = 'customer_engineer';
//       else detectedRole = 'admin';
//     }
//     setUserRole(detectedRole);
//     sessionStorage.setItem('hoags_role', detectedRole);
//     setPendingSession(s);
//     setShowSplash(true);
//   };

//   const handleSplashDone = () => {
//     setShowSplash(false);
//     setSession(pendingSession);
//     setPendingSession(null);
//   };

//   const handleSignOut = () => {
//     signOut();
//     sessionStorage.removeItem('hoags_role');
//     setUserRole('user');
//     setSession(null);
//     setActivePage('dashboard');
//   };

//   const userId = session?.getIdToken()?.payload?.sub || null;

//   if (authLoading) {
//     return (
//       <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
//         justifyContent: 'center', background: '#f8f9fa', flexDirection: 'column', gap: 16 }}>
//         <style>{`@keyframes spin { to { transform:rotate(360deg); } }`}</style>
//         <div style={{ width: 28, height: 28, border: '3px solid rgba(220,38,38,0.15)',
//           borderTopColor: '#DC2626', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}/>
//         <p style={{ color: '#8E8E93', fontSize: 14 }}>Loading…</p>
//       </div>
//     );
//   }

//   if (showSplash) return <SplashLoader onDone={handleSplashDone} />;
//   if (!session)    return <SignIn onSignedIn={handleSignedIn} />;

//   const isAdmin   = userRole === 'admin';
//   const isMgr     = userRole === 'service_manager';
//   const isCE      = userRole === 'customer_engineer';

//   if (isMgr) return (
//     <div className="app-layout">
//       <main className="main-content" style={{marginLeft:0,paddingTop:24}}>
//         <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16,paddingRight:4}}>
//           <button onClick={handleSignOut} style={{padding:'8px 16px',borderRadius:10,border:'1.5px solid rgba(0,0,0,.1)',background:'#fff',color:'#636366',fontSize:13,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
//             Sign Out
//           </button>
//         </div>
//         <ServiceManager session={session}/>
//       </main>
//     </div>
//   );

//   if (isCE) return (
//     <div className="app-layout">
//       <main className="main-content" style={{marginLeft:0,paddingTop:24}}>
//         <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16,paddingRight:4}}>
//           <button onClick={handleSignOut} style={{padding:'8px 16px',borderRadius:10,border:'1.5px solid rgba(0,0,0,.1)',background:'#fff',color:'#636366',fontSize:13,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
//             Sign Out
//           </button>
//         </div>
//         <CustomerEngineer session={session}/>
//       </main>
//     </div>
//   );

//   // ── Page router — handles miscellaneous sub-pages directly ────────────────
//   const renderPage = () => {
//     switch (activePage) {
//       case 'dashboard':  return <DeviceList userId={userId} isAdmin={isAdmin}/>;
//       case 'recharge':   return <RechargeManagement userId={userId} isAdmin={isAdmin}/>;
//       case 'analytics':  return isAdmin ? <Analytics session={session}/> : <DeviceList userId={userId} isAdmin={false}/>;
//       case 'support':    return isAdmin ? <Support/> : <DeviceList userId={userId} isAdmin={false}/>;
//       case 'profile':    return <Profile session={session} onSignOut={handleSignOut} role={userRole}/>;

//       case 'miscellaneous':
//         if (!isAdmin) return <DeviceList userId={userId} isAdmin={false}/>;
//         // Route to specific sub-page, or show the default Miscellaneous landing
//         switch (miscSubPage) {
//           case 'tamper':        return <TamperPage devices={allDevices}/>;
//           case 'dryrun':        return <Miscellaneous subPage="dryrun"/>;
//           case 'refreshments':  return <RefreshmentsPage devices={allDevices}/>;
//           case 'batteryhealth': return <BatteryHealthPage devices={allDevices}/>;
//           default:              return <Miscellaneous subPage={miscSubPage}/>;
//         }

//       default: return <DeviceList userId={userId} isAdmin={isAdmin}/>;
//     }
//   };

//   const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

//   return (
//     <div className="app-layout">
//       {isMobile && !sidebarCollapsed && (
//         <div onClick={toggleSidebar} style={{
//           position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
//           zIndex: 399, backdropFilter: 'blur(2px)',
//         }}/>
//       )}
//       <Sidebar
//         activePage={activePage} setActivePage={(page) => { if (page !== 'miscellaneous') setMiscSubPage(null); setActivePage(page); }}
//         onSignOut={handleSignOut} session={session}
//         collapsed={sidebarCollapsed} onToggle={toggleSidebar} role={userRole}
//         miscSubPage={miscSubPage} setMiscSubPage={(sub) => { setMiscSubPage(sub); setActivePage('miscellaneous'); }}
//       />
//       <main className="main-content" style={{ transition: 'margin-left 0.28s cubic-bezier(.4,0,.2,1)' }}>
//         <div className="mobile-topbar">
//           <button onClick={toggleSidebar} style={{
//             width: 36, height: 36, borderRadius: 9,
//             background: 'rgba(0,0,0,0.06)', border: 'none',
//             cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
//           }}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//               <path d="M3 6h18M3 12h18M3 18h18" stroke="#1c1c1e" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//           <span style={{ fontSize: 15, fontWeight: 700, color: '#1c1c1e', letterSpacing: -.3 }}>Havells Admin</span>
//           <div style={{ width: 36 }}/>
//         </div>
//         {renderPage()}
//         <Footer/>
//       </main>
//       <GlobalTamToast
//         alerts={globalTamAlerts}
//         onDismiss={(key) => setGlobalTamAlerts(prev => prev.filter(a => a.key !== key))}
//       />
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import DeviceList from './pages/DeviceList';
import RechargeManagement from './pages/RechargeManagement';
import Analytics from './pages/Analytics';
import Miscellaneous from './pages/Miscellaneous';
import TamperPage from './pages/TamperPage';
import RefreshmentsPage from './pages/RefreshmentsPage';
import BatteryHealthPage from './pages/BatteryHealthPage';
import RelocationPage from './pages/RelocationPage';
import MiscellaneousMenu from './pages/MiscellaneousMenu';
import RoleManagement from './pages/RoleManagement';
import Profile from './pages/Profile';
import SignIn from './pages/SignIn';
import { getCurrentSession, signOut } from './cognito';
import Support from './pages/Support';
import ServiceManager from './pages/ServiceManager';
import CustomerEngineer from './pages/CustomerEngineer';
import { useMqttProxy } from './mqttProxy';
import { aesDecrypt, hexToString } from './cryptoUtils';
import { getManagerByEmail, getCEByEmail } from './supportConfig';
import './App.css';

// ── Global TAM config & helpers ─────────────────────────────────────────────
const GLOBAL_TAM_CFG = {
  '1': { title:'Pump Tamper Detected',        badge:'PUMP TAMPER',        color:'#FF3B30', bg:'linear-gradient(135deg,#FF3B30,#CC0000)', shadow:'rgba(255,59,48,.4)' },
  '2': { title:'Flow Sensor Tamper Detected', badge:'FLOW SENSOR TAMPER', color:'#FF9F0A', bg:'linear-gradient(135deg,#FF9F0A,#CC7A00)', shadow:'rgba(255,159,10,.4)' },
};
const RESP_TOPIC_FOR = (mac) => `/hoags/livpure/lotier/waas/response/${mac.replace(/[^a-f0-9]/gi,'').toLowerCase()}/`;
const TAM_KEY = (mac) => `hoags_tam_history_${mac}`;

function globalSaveTamEvent(mac, tamCode, deviceName, location, serialNo) {
  try {
    const raw = JSON.parse(localStorage.getItem(TAM_KEY(mac)) || '[]');
    const cfg = GLOBAL_TAM_CFG[tamCode]; if (!cfg) return false;
    const cutoff24h = Date.now() - 24 * 60 * 60 * 1000;

    const existingIdx = raw.findIndex(h => h.tamCode === tamCode);
    const existing    = existingIdx >= 0 ? raw[existingIdx] : null;
    const suppressAlert = existing &&
      new Date(existing.detectedAt).getTime() > cutoff24h;

    const newEntry = {
      id: Date.now(), tamCode, type: cfg.badge, title: cfg.title,
      device: deviceName, mac,
      location: location || '',
      serialNo: serialNo || '',
      detectedAt: new Date().toISOString(), acknowledgedAt: null,
    };

    let updated;
    if (existingIdx >= 0) {
      updated = [...raw];
      updated[existingIdx] = newEntry;
    } else {
      updated = [newEntry, ...raw];
    }
    localStorage.setItem(TAM_KEY(mac), JSON.stringify(updated.slice(0, 200)));
    return !suppressAlert;
  } catch(e) { return false; }
}

// ── Global TAM Toast ─────────────────────────────────────────────────────────
function GlobalTamToast({ alerts, onDismiss }) {
  if (alerts.length === 0) return null;
  const alert = alerts[0];
  const cfg = GLOBAL_TAM_CFG[alert.tamCode];
  if (!cfg) return null;
  return (
    <div style={{
      position:'fixed', bottom:24, right:24, zIndex:999999,
      width:320, borderRadius:18,
      background:'#fff',
      boxShadow:'0 12px 48px rgba(0,0,0,.25), 0 2px 8px rgba(0,0,0,.1)',
      border:`1.5px solid ${cfg.color}30`,
      overflow:'hidden',
      animation:'gTamSlideIn .35s cubic-bezier(.34,1.56,.64,1)',
      fontFamily:"-apple-system,BlinkMacSystemFont,'SF Pro Display',sans-serif",
    }}>
      <div style={{ height:4, background:cfg.bg }}/>
      <div style={{ padding:'14px 16px 16px', display:'flex', flexDirection:'column', gap:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{
            width:36, height:36, borderRadius:10, flexShrink:0,
            background:cfg.bg,
            display:'flex', alignItems:'center', justifyContent:'center',
            boxShadow:`0 3px 10px ${cfg.shadow}`,
            animation:'gTamPulse 1.8s ease-in-out infinite',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 19h20L12 2Z" fill="white" fillOpacity=".3"
                stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
              <path d="M12 9v5" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
              <circle cx="12" cy="17" r="1.2" fill="white"/>
            </svg>
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:13, fontWeight:800, color:'#1c1c1e', marginBottom:1 }}>{cfg.title}</div>
            <div style={{ fontSize:10, fontWeight:700, color:cfg.color, letterSpacing:.6 }}>{cfg.badge}</div>
          </div>
          <button onClick={()=>onDismiss(alert.key)} style={{
            width:24, height:24, borderRadius:'50%', border:'none',
            background:'rgba(0,0,0,.07)', cursor:'pointer', flexShrink:0,
            display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:13, color:'#636366',
          }}>×</button>
        </div>
        <div style={{
          fontSize:12, color:'#48484a', lineHeight:1.55,
          background:'rgba(0,0,0,.025)', borderRadius:10, padding:'9px 12px',
        }}>
          <div><strong>Device:</strong> {alert.deviceName}</div>
          <div style={{ fontFamily:'monospace', fontSize:11, color:'#8E8E93' }}>{alert.mac}</div>
          {alert.location && <div style={{ fontSize:11, color:'#8E8E93', marginTop:2 }}>📍 {alert.location}</div>}
          {alert.serialNo  && <div style={{ fontSize:11, color:'#8E8E93' }}>🔖 {alert.serialNo}</div>}
          <div style={{ marginTop:3, color:'#8E8E93', fontSize:11 }}>
            {new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit',hour12:true})} · {new Date().toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}
          </div>
        </div>
        <button onClick={()=>onDismiss(alert.key)} style={{
          flex:1, padding:'9px', borderRadius:10, border:'none',
          background:cfg.bg, color:'#fff', fontWeight:700, fontSize:12,
          cursor:'pointer', fontFamily:'inherit',
          boxShadow:`0 2px 8px ${cfg.shadow}`,
        }}>Acknowledge</button>
        <div style={{ fontSize:10, color:'#aeaeb2', textAlign:'center' }}>Saved to tamper history</div>
      </div>
      <style>{`
        @keyframes gTamSlideIn { from{opacity:0;transform:translateX(120px) scale(.9)} to{opacity:1;transform:translateX(0) scale(1)} }
        @keyframes gTamPulse   { 0%,100%{transform:scale(1)} 50%{transform:scale(1.08)} }
      `}</style>
    </div>
  );
}

const SPLASH_STEPS = [
  { icon: '🔐', text: 'Verifying your identity…'    },
  { icon: '🌐', text: 'Connecting to Havells Cloud…'  },
  { icon: '📡', text: 'Initialising MQTT proxy…'    },
  { icon: '✅',   text: 'All set! Welcome back.'        },
];

function SplashLoader({ onDone }) {
  const [idx, setIdx] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (idx >= SPLASH_STEPS.length - 1) {
      const t = setTimeout(onDone, 1200);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setFade(false);
      setTimeout(() => { setIdx(i => i + 1); setFade(true); }, 300);
    }, 2000);
    return () => clearTimeout(t);
  }, [idx, onDone]);

  const step = SPLASH_STEPS[idx];
  const progress = ((idx + 1) / SPLASH_STEPS.length) * 100;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#f8f9fa',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 0,
    }}>
      <style>{`
        @keyframes splashPulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:.85} }
        @keyframes iosBar { from{opacity:1} to{opacity:.15} }
      `}</style>

      <div style={{
        width: 80, height: 80, borderRadius: 18, background: 'transparent',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 24,
        animation: 'splashPulse 2s ease-in-out infinite', overflow: 'visible',
      }}>
        <img src="/havells-logo.png" alt="Havells" style={{ height: 70, width: 'auto', objectFit: 'contain' }}/>
      </div>

      <div style={{ fontSize: 26, fontWeight: 800, color: '#1c1c1e', letterSpacing: -.5, marginBottom: 6,
        fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>Havells Waas</div>
      <div style={{ fontSize: 13, color: 'rgba(0,0,0,.4)', marginBottom: 52,
        fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>Smart Device Management</div>

      <div style={{ position: 'relative', width: 44, height: 44, marginBottom: 32 }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} style={{
            position: 'absolute', top: '50%', left: '50%',
            width: 3.5, height: 10, borderRadius: 2, background: '#DC2626',
            transformOrigin: '50% 160%',
            transform: `rotate(${i * 30}deg) translateX(-50%)`,
            animation: `iosBar 1s linear ${-(12 - i) / 12}s infinite`,
          }} />
        ))}
      </div>

      <div style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.3s ease', textAlign: 'center',
        marginBottom: 40, fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>
        <div style={{ fontSize: 22, marginBottom: 8 }}>{step.icon}</div>
        <div style={{ fontSize: 14, color: 'rgba(0,0,0,.55)', fontWeight: 500 }}>{step.text}</div>
      </div>

      <div style={{ width: 200, height: 3, background: 'rgba(0,0,0,.08)', borderRadius: 999, overflow: 'hidden' }}>
        <div style={{
          height: '100%', borderRadius: 999,
          background: 'linear-gradient(90deg,#DC2626,#EF4444)',
          width: `${progress}%`, transition: 'width 0.5s ease',
          boxShadow: '0 0 8px rgba(220,38,38,.4)',
        }} />
      </div>

      <div style={{ display: 'flex', gap: 6, marginTop: 16 }}>
        {SPLASH_STEPS.map((_, i) => (
          <div key={i} style={{
            width: i === idx ? 18 : 6, height: 6, borderRadius: 3,
            background: i <= idx ? '#DC2626' : 'rgba(0,0,0,.1)',
            transition: 'all 0.4s ease',
          }} />
        ))}
      </div>
    </div>
  );
}

export default function App() {
  const [session,          setSession]          = useState(null);
  const [authLoading,      setAuthLoading]      = useState(true);
  const [activePage,       setActivePage]       = useState('dashboard');
  const [miscSubPage,      setMiscSubPage]      = useState(null);
  const [showSplash,       setShowSplash]       = useState(false);
  const [pendingSession,   setPendingSession]   = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [userRole,         setUserRole]         = useState(() => sessionStorage.getItem('hoags_role') || 'user');
  const [userPermissions,  setUserPermissions]  = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('hoags_permissions') || '[]'); } catch { return []; }
  });
  const [globalTamAlerts,  setGlobalTamAlerts]  = useState([]);
  const [allDevices,       setAllDevices]       = useState([]);
  const tamSeenRef = useRef(new Set());

  const { connected, subscribe } = useMqttProxy();
  const toggleSidebar = () => setSidebarCollapsed(c => !c);

  useEffect(() => {
    fetch('/api/admin-devices', { headers:{'ngrok-skip-browser-warning':'true'} })
      .then(r => r.json())
      .then(data => {
        const arr = Array.isArray(data) ? data : (data.registrations??data.data??data.devices??[]);
        // Dedupe by normalized MAC — the registration API can return the same
        // device multiple times (re-registrations / stale rows), which
        // previously caused MQTT subscriptions (and rendered tamper alerts)
        // to fire multiple times for a single real event.
        const byMac = new Map();
        arr.forEach(d => {
          const mac = (d.mac_id || d.macid || '').replace(/[^a-fA-F0-9]/g, '').toLowerCase();
          if (mac && !byMac.has(mac)) byMac.set(mac, d);
        });
        setAllDevices(Array.from(byMac.values()));
      }).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!connected || allDevices.length === 0) return;
    const unsubs = allDevices.map(device => {
      const mac = (device.mac_id||device.macid||'').replace(/[^a-fA-F0-9]/g,'').toLowerCase();
      if (!mac) return null;
      const topic = RESP_TOPIC_FOR(mac);
      return subscribe(topic, async (message) => {
        try {
          const raw = typeof message === 'string' ? message : JSON.stringify(message);

          // ── Dedupe BEFORE the async decrypt ────────────────────────────
          // Keyed on the raw (still-encrypted) payload + a short time bucket,
          // so it works without waiting on decryption and closes the race
          // where several concurrent callbacks (e.g. leftover duplicate
          // subscriptions) all pass the "not seen yet" check before any of
          // them finishes awaiting aesDecrypt. A 5s bucket collapses
          // near-simultaneous re-deliveries of the same message while still
          // letting genuinely separate tamper events through if they're more
          // than 5s apart, even with an identical payload shape.
          const msgKey = `${mac}-${raw}-${Math.floor(Date.now()/5000)}`;
          if (tamSeenRef.current.has(msgKey)) return;
          tamSeenRef.current.add(msgKey);
          setTimeout(() => tamSeenRef.current.delete(msgKey), 15000);

          let json;
          try { json = JSON.parse(raw); } catch { return; }
          if (json.VAL && /^[0-9a-fA-F]+$/.test(json.VAL) && json.VAL.length > 20) {
            try {
              const k2 = window.__hoagsK2?.[mac];
              if (k2) {
                const decHex = await aesDecrypt(json.VAL, k2);
                json = JSON.parse(hexToString(decHex));
              } else { return; }
            } catch { return; }
          }
          if (json.CMD !== 'TAM') return;
          const tamCode = String(json.VAL);
          if (!GLOBAL_TAM_CFG[tamCode]) return;
          const deviceName = device.friendly_name || device.friendlyname || mac;
          const location   = device.location || device._registration?.location || '';
          const serialNo   = device.version_no || device.versionNo || '';
          const isNew = globalSaveTamEvent(mac, tamCode, deviceName, location, serialNo);
          if (!isNew) return;
          const alertKey = `${mac}-${tamCode}-${Date.now()}`;
          setGlobalTamAlerts(prev => [{ key:alertKey, mac, tamCode, deviceName, location, serialNo }, ...prev]);
          fetch('/api/tamper-alert', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ tamCode, deviceName, mac, tamType: GLOBAL_TAM_CFG[tamCode]?.badge,
              detectedAt: new Date().toISOString(), location, serialNo }),
          }).catch(()=>{});
        } catch(e) {}
      });
    }).filter(Boolean);
    return () => unsubs.forEach(u => u && u());
  }, [connected, allDevices, subscribe]);

  useEffect(() => {
    getCurrentSession()
      .then(s => setSession(s))
      .catch(() => setSession(null))
      .finally(() => setAuthLoading(false));
  }, []);

  // Only these emails may hold the full Admin role, regardless of which
  // Cognito pool successfully authenticated them. Ayesha is promoted here
  // too (per the role table: she gets the real admin dashboard, not the
  // restricted Manager page). Add more here later if needed.
  // Only kishore is Super Admin. Ayesha and others created via Role Management are 'admin'.
  const SUPER_ADMIN_EMAILS  = ['kishore@hoags.in'];
  const ADMIN_ALLOWLIST     = ['kishore@hoags.in', 'ayeshakhan@hoags.in', 'hari.babu@havells.com'];

  const handleSignedIn = async (s, role = 'user') => {
    const email = (s?.getIdToken()?.payload?.email || '').toLowerCase();
    let detectedRole = role;
    let permissions = [];

    if (!role || role === 'user') {
      if (getManagerByEmail(email)) detectedRole = 'service_manager';
      else if (getCEByEmail(email)) detectedRole = 'customer_engineer';
      else detectedRole = 'admin';
    }

    // Look up the dynamic account record (created via Role Management) — it
    // refines service_manager vs customer_engineer (both share MANAGER_POOL),
    // supplies permissions for sidebar gating, and is also checked below for
    // the Super Admin allowlist.
    let acct = null;
    try {
      const res = await fetch(`/api/accounts?email=${encodeURIComponent(email)}`);
      acct = await res.json();
    } catch (e) { /* network hiccup — fall back to assumed role / static config */ }

    if (acct && acct.role) {
      detectedRole = acct.role;
      permissions = acct.permissions || [];
    } else {
      const staticMgr = getManagerByEmail(email);
      if (staticMgr) permissions = staticMgr.permissions || [];
    }

    // kishore → super_admin. ayesha → admin. Everyone else determined by account record.
    if (SUPER_ADMIN_EMAILS.includes(email)) {
      detectedRole = 'super_admin';
    } else if (ADMIN_ALLOWLIST.includes(email)) {
      detectedRole = 'admin';
    }

    // Hard guard: super_admin only for SUPER_ADMIN_EMAILS; admin only for ADMIN_ALLOWLIST or explicit DB record.
    if (detectedRole === 'super_admin' && !SUPER_ADMIN_EMAILS.includes(email)) {
      detectedRole = getManagerByEmail(email) ? 'service_manager' : 'unauthorized';
    }
    if (detectedRole === 'admin' && !ADMIN_ALLOWLIST.includes(email) && !(acct && acct.role === 'admin')) {
      detectedRole = getManagerByEmail(email) ? 'service_manager' : 'unauthorized';
    }
    if (detectedRole === 'unauthorized') {
      signOut();
      window.alert('This account is not authorized for admin access. Please contact your administrator.');
      return;
    }
    setUserPermissions(permissions);
    sessionStorage.setItem('hoags_permissions', JSON.stringify(permissions));
    setUserRole(detectedRole);
    sessionStorage.setItem('hoags_role', detectedRole);
    // All roles land on dashboard — managers now always show ServiceManager there
    setActivePage('dashboard');
    setPendingSession(s);
    setShowSplash(true);
  };

  const handleSplashDone = () => {
    setShowSplash(false);
    setSession(pendingSession);
    setPendingSession(null);
  };

  const handleSignOut = () => {
    signOut();
    sessionStorage.removeItem('hoags_role');
    setUserRole('user');
    setSession(null);
    setActivePage('dashboard');
  };

  const userId = session?.getIdToken()?.payload?.sub || null;

  if (authLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#f8f9fa', flexDirection: 'column', gap: 16 }}>
        <style>{`@keyframes spin { to { transform:rotate(360deg); } }`}</style>
        <div style={{ width: 28, height: 28, border: '3px solid rgba(220,38,38,0.15)',
          borderTopColor: '#DC2626', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}/>
        <p style={{ color: '#8E8E93', fontSize: 14 }}>Loading…</p>
      </div>
    );
  }

  if (showSplash) return <SplashLoader onDone={handleSplashDone} />;
  if (!session)    return <SignIn onSignedIn={handleSignedIn} />;

  const isAdmin   = userRole === 'admin' || userRole === 'super_admin';
  const isMgr     = userRole === 'service_manager';
  const isCE      = userRole === 'customer_engineer';
  const isMobile  = typeof window !== 'undefined' && window.innerWidth < 768;

  if (isCE) {
    // CE gets a full sidebar + page routing — same renderPage logic but
    // 'dashboard' maps to CustomerEngineer, others share the same pages as admin/mgr
    const renderCEPage = () => {
      switch (activePage) {
        case 'dashboard':      return <DeviceList userId={userId} isAdmin={false} role={userRole}/>;
        case 'recharge':       return <RechargeManagement userId={userId} isAdmin={false}/>;
        case 'support':        return <CustomerEngineer session={session}/>;
        case 'rolemanagement': return <RoleManagement session={session} role={userRole}/>;
        case 'profile':        return <Profile session={session} onSignOut={handleSignOut} role={userRole}/>;
        case 'miscellaneous':
          switch (miscSubPage) {
            case 'tamper':        return <TamperPage devices={allDevices}/>;
            case 'dryrun':        return <Miscellaneous subPage="dryrun"/>;
            case 'refreshments':  return <RefreshmentsPage devices={allDevices}/>;
            case 'batteryhealth': return <BatteryHealthPage devices={allDevices}/>;
            case 'relocation':    return <RelocationPage/>;
            default:              return <MiscellaneousMenu onSelect={setMiscSubPage}/>;
          }
        default: return <CustomerEngineer session={session}/>;
      }
    };
    return (
    <div className="app-layout">
      {isMobile && !sidebarCollapsed && (
        <div onClick={toggleSidebar} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          zIndex: 399, backdropFilter: 'blur(2px)',
        }}/>
      )}
      <Sidebar
        activePage={activePage} setActivePage={(page) => { if (page !== 'miscellaneous') setMiscSubPage(null); setActivePage(page); }}
        onSignOut={handleSignOut} session={session}
        collapsed={sidebarCollapsed} onToggle={toggleSidebar} role={userRole} permissions={userPermissions}
        miscSubPage={miscSubPage} setMiscSubPage={(sub) => { setMiscSubPage(sub); setActivePage('miscellaneous'); }}
      />
      <main className="main-content" style={{ transition: 'margin-left 0.28s cubic-bezier(.4,0,.2,1)' }}>
        <div className="mobile-topbar">
          <button onClick={toggleSidebar} style={{
            width: 36, height: 36, borderRadius: 9,
            background: 'rgba(0,0,0,0.06)', border: 'none',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M3 12h18M3 18h18" stroke="#1c1c1e" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <span style={{ fontSize: 15, fontWeight: 700, color: '#1c1c1e', letterSpacing: -.3 }}>Havells</span>
          <div style={{ width: 36 }}/>
        </div>
        {renderCEPage()}
        <Footer/>
      </main>
    </div>
    );
  }

  const renderPage = () => {
    const canViewAnalytics = isAdmin || (isMgr && (userPermissions.includes('all') || userPermissions.includes('view_analytics')));
    const canRecharge      = isAdmin || (isMgr && (userPermissions.includes('all') || userPermissions.includes('recharge')));
    const canSupport       = isAdmin || (isMgr && (userPermissions.includes('all') || userPermissions.includes('add_engineers')));

    switch (activePage) {
      case 'dashboard':       return <DeviceList userId={userId} isAdmin={isAdmin} role={userRole} session={session}/>;
      case 'recharge':        return canRecharge ? <RechargeManagement userId={userId} isAdmin={isAdmin}/> : <Miscellaneous subPage={null}/>;
      case 'analytics':       return canViewAnalytics ? <Analytics session={session}/> : <Miscellaneous subPage={null}/>;
      case 'support':         return <Support/>;
      case 'rolemanagement':  return (isAdmin || isMgr) ? <RoleManagement session={session} role={userRole}/> : <DeviceList userId={userId} isAdmin={false}/>;
      case 'profile':         return <Profile session={session} onSignOut={handleSignOut} role={userRole}/>;

      case 'miscellaneous':
        switch (miscSubPage) {
          case 'tamper':        return <TamperPage devices={allDevices}/>;
          case 'dryrun':        return <Miscellaneous subPage="dryrun"/>;
          case 'refreshments':  return <RefreshmentsPage devices={allDevices}/>;
          case 'batteryhealth': return <BatteryHealthPage devices={allDevices}/>;
          case 'relocation':    return <RelocationPage/>;
          default:              return <MiscellaneousMenu onSelect={setMiscSubPage}/>;
        }

      default: return <DeviceList userId={userId} isAdmin={isAdmin}/>;
    }
  };

  return (
    <div className="app-layout">
      {isMobile && !sidebarCollapsed && (
        <div onClick={toggleSidebar} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          zIndex: 399, backdropFilter: 'blur(2px)',
        }}/>
      )}
      <Sidebar
        activePage={activePage} setActivePage={(page) => { if (page !== 'miscellaneous') setMiscSubPage(null); setActivePage(page); }}
        onSignOut={handleSignOut} session={session}
        collapsed={sidebarCollapsed} onToggle={toggleSidebar} role={userRole} permissions={userPermissions}
        miscSubPage={miscSubPage} setMiscSubPage={(sub) => { setMiscSubPage(sub); setActivePage('miscellaneous'); }}
      />
      <main className="main-content" style={{ transition: 'margin-left 0.28s cubic-bezier(.4,0,.2,1)' }}>
        <div className="mobile-topbar">
          <button onClick={toggleSidebar} style={{
            width: 36, height: 36, borderRadius: 9,
            background: 'rgba(0,0,0,0.06)', border: 'none',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M3 12h18M3 18h18" stroke="#1c1c1e" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <span style={{ fontSize: 15, fontWeight: 700, color: '#1c1c1e', letterSpacing: -.3 }}>Havells Waas</span>
          <div style={{ width: 36 }}/>
        </div>
        {renderPage()}
        <Footer/>
      </main>
      <GlobalTamToast
        alerts={globalTamAlerts}
        onDismiss={(key) => setGlobalTamAlerts(prev => prev.filter(a => a.key !== key))}
      />
    </div>
  );
}
